import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  CreateApiConnectionRequest,
  UpdateApiConnectionRequest,
} from 'src/api/FiretrolApiClient';
import { apiConnectionApiClient } from 'src/api/FiretrolApiClientInstances';
import { invalidateFor } from 'src/api/queries/invalidationMap';

export function useCreateApiConnection() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (request: CreateApiConnectionRequest) =>
      apiConnectionApiClient.create(request),
    meta: { successMessage: 'Connection created!', suppressErrorToast: true },
    onSettled: () => invalidateFor('apiConnection.save', qc),
  });
}

export interface UpdateApiConnectionArgs {
  id: string;
  request: UpdateApiConnectionRequest;
}

export function useUpdateApiConnection() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, request }: UpdateApiConnectionArgs) =>
      apiConnectionApiClient.update(id, request),
    meta: { successMessage: 'Connection updated!', suppressErrorToast: true },
    onSettled: () => invalidateFor('apiConnection.save', qc),
  });
}

export function useDeleteApiConnection() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => apiConnectionApiClient.delete(id),
    meta: {
      successMessage: 'Connection deleted!',
      errorContext: 'delete API connection',
    },
    onSettled: () => invalidateFor('apiConnection.save', qc),
  });
}
